import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

interface ErrorDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    errorMessage: string;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
    open,
    setOpen,
    errorMessage,
}) => {
    const cancelButtonRef = useRef(null);

    const onClose = () => {
        setOpen(false);
    };

    return (
        <Transition show={open} as={Fragment}>
            <Dialog
                className="relative z-[100]"
                initialFocus={cancelButtonRef}
                onClose={onClose}
            >
                {/* Overlay */}
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-jtc-very-dark-grey bg-opacity-50 backdrop-blur-sm" />
                </Transition.Child>

                {/* Dialog Panel Container */}
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-md bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mt-3 text-left sm:ml-4 sm:mt-0">
                                            <Dialog.Title
                                                as="h3"
                                                className="text-base font-semibold leading-6 text-jtc-very-dark-grey"
                                            >
                                                An Error Occurred
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-jtc-very-dark-grey">{errorMessage}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-row-reverse px-4 pb-6 sm:px-6">
                                    <button
                                        className="jtc-secondary-button m-0 w-[115px]"
                                        onClick={onClose}
                                        ref={cancelButtonRef}
                                    >
                                        <span>
                                            <span>Close</span>
                                        </span>
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
